/**
 * Spring Boot REST API
 * \"Spring Boot REST API for Online Store\"
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Observable } from "rxjs";
import { Headers } from "../Headers";
import { HttpResponse } from "../HttpResponse";

import { AddUserReq } from "../model/addUserReq";
import { AddUserRes } from "../model/addUserRes";
import { AppHqErrorResponse } from "../model/appHqErrorResponse";
import { CaptchaFrontEndData } from "../model/captchaFrontEndData";
import { FElogging } from "../model/fElogging";
import { Response } from "../model/response";
import { UserAppResList } from "../model/userAppResList";
import { UserDetailsRes } from "../model/userDetailsRes";

export abstract class UserProfileServiceInterface {
  /**
   * activationApprovedByCustomer
   *
   * @param id id
   * @param username username
   */

  public abstract activationApprovedByCustomerUsingPUT(
    id: string,
    username: string,
    observe?: "body",
    headers?: Headers
  ): Observable<AddUserRes>;
  public abstract activationApprovedByCustomerUsingPUT(
    id: string,
    username: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<AddUserRes>>;
  /**
   * activationApprovedByRhenus
   *
   * @param username username
   */

  public abstract activationApprovedByRhenusUsingPUT(
    username: string,
    observe?: "body",
    headers?: Headers
  ): Observable<AddUserRes>;
  public abstract activationApprovedByRhenusUsingPUT(
    username: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<AddUserRes>>;
  /**
   * activationRejectedByCustomer
   *
   * @param id id
   * @param username username
   */

  public abstract activationRejectedByCustomerUsingPUT(
    id: string,
    username: string,
    observe?: "body",
    headers?: Headers
  ): Observable<any>;
  public abstract activationRejectedByCustomerUsingPUT(
    id: string,
    username: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any>>;
  /**
   * activationRejectedByRhenus
   *
   * @param username username
   */

  public abstract activationRejectedByRhenusUsingPUT(
    username: string,
    observe?: "body",
    headers?: Headers
  ): Observable<any>;
  public abstract activationRejectedByRhenusUsingPUT(
    username: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any>>;
  /**
   * audio
   *
   * @param audioType audioType
   */

  public abstract audioUsingGET(
    audioType: string,
    observe?: "body",
    headers?: Headers
  ): Observable<any>;
  public abstract audioUsingGET(
    audioType: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any>>;
  /**
   * audio
   *
   */

  public abstract audioUsingGET1(
    observe?: "body",
    headers?: Headers
  ): Observable<any>;
  public abstract audioUsingGET1(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any>>;
  /**
   * Get all pending activation for Customer.
   *
   * @param id id
   */

  public abstract getAllPendingActivationForCustomer(
    id: string,
    observe?: "body",
    headers?: Headers
  ): Observable<any[]>;
  public abstract getAllPendingActivationForCustomer(
    id: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any[]>>;
  /**
   * Get all pending activation for Rhenus.
   *
   */

  public abstract getAllPendingActivationForRhenus(
    observe?: "body",
    headers?: Headers
  ): Observable<any[]>;
  public abstract getAllPendingActivationForRhenus(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any[]>>;
  /**
   * Get image by index.
   *
   * @param index index
   */

  public abstract getImage(
    index: number,
    observe?: "body",
    headers?: Headers
  ): Observable<any>;
  public abstract getImage(
    index: number,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any>>;
  /**
   * Get user details for logged in user
   *
   */

  public abstract getUser(
    observe?: "body",
    headers?: Headers
  ): Observable<UserDetailsRes>;
  public abstract getUser(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<UserDetailsRes>>;
  /**
   * Get all apps the logged in user has access to
   *
   */

  public abstract getUserApps(
    observe?: "body",
    headers?: Headers
  ): Observable<UserAppResList>;
  public abstract getUserApps(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<UserAppResList>>;
  /**
   * User sign up
   *
   * @param addUserReq addUserReq
   */

  public abstract signUpUser(
    addUserReq: AddUserReq,
    observe?: "body",
    headers?: Headers
  ): Observable<any>;
  public abstract signUpUser(
    addUserReq: AddUserReq,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any>>;
  /**
   * Initialize
   *
   * @param howMany howMany
   */

  public abstract start(
    howMany: string,
    observe?: "body",
    headers?: Headers
  ): Observable<CaptchaFrontEndData>;
  public abstract start(
    howMany: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<CaptchaFrontEndData>>;
  /**
   * User activation
   *
   * @param token token
   */

  public abstract userActivation(
    token: string,
    observe?: "body",
    headers?: Headers
  ): Observable<AddUserRes>;
  public abstract userActivation(
    token: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<AddUserRes>>;
  /**
   * Endpoint to log FE logs
   *
   * @param log log
   */

  public abstract webLogging(
    log: FElogging,
    observe?: "body",
    headers?: Headers
  ): Observable<Response>;
  public abstract webLogging(
    log: FElogging,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<Response>>;
}
